(function () {
    'use strict';

    var SECTION_SELECTOR = '.vutc-section';
    var productJsonCache = new Map();
    var remoteTemplateCache = new Map();

    function parseJSONSafe(text, fallback) {
        if (!text) return fallback;
        try {
            return JSON.parse(text);
        } catch (e) {
            return fallback;
        }
    }

    function normalizeHandle(value) {
        return String(value || '').trim().toLowerCase();
    }

    function escapeHtml(text) {
        var temp = document.createElement('div');
        temp.textContent = String(text || '');
        return temp.innerHTML;
    }

    function getConfig(section) {
        var configNode = section.querySelector('.js-vutc-config');
        var config = parseJSONSafe(configNode ? configNode.textContent : '{}', {});

        return {
            sectionId: String(config.sectionId || section.getAttribute('data-section-id') || ''),
            activeTab: String(config.activeTab || 'related'),
            relatedLimit: Number(config.relatedLimit || 8),
            recommendationsUrl: String(config.recommendationsUrl || ''),
            recentlyViewedStorageKey: String(config.recentlyViewedStorageKey || 'vpt_recently_viewed_handles'),
            recentlyViewedLimit: Number(config.recentlyViewedLimit || 8)
        };
    }

    function readRecentHandles(storageKey) {
        if (!storageKey) return [];

        var raw = '';
        try {
            raw = window.localStorage.getItem(storageKey) || '';
        } catch (e) {
            return [];
        }

        if (!raw) return [];

        var parsed = parseJSONSafe(raw, null);
        if (Array.isArray(parsed)) {
            return parsed.map(normalizeHandle).filter(Boolean);
        }

        return String(raw)
            .split(',')
            .map(normalizeHandle)
            .filter(Boolean);
    }

    function writeRecentHandles(storageKey, handles) {
        if (!storageKey) return;
        try {
            window.localStorage.setItem(storageKey, JSON.stringify(handles));
        } catch (e) {
            // no-op
        }
    }

    function getCurrentProductHandle(section) {
        return normalizeHandle(section.getAttribute('data-current-product-handle'));
    }

    function getCurrentProductId(section) {
        var raw = section.getAttribute('data-current-product-id') || '';
        var parsed = Number(raw);
        if (!Number.isFinite(parsed) || parsed <= 0) return null;
        return parsed;
    }

    function updateCurrentProductInStorage(section, config) {
        var isProductPage = section.getAttribute('data-is-product-page') === 'true';
        if (!isProductPage) return;

        var currentHandle = getCurrentProductHandle(section);
        if (!currentHandle) return;

        var handles = readRecentHandles(config.recentlyViewedStorageKey);
        handles = handles.filter(function (h) {
            return h !== currentHandle;
        });

        handles.unshift(currentHandle);
        handles = handles.slice(0, 20);

        writeRecentHandles(config.recentlyViewedStorageKey, handles);
    }

    function setActiveTab(section, tabKey) {
        var target = tabKey === 'recent' ? 'recent' : 'related';

        section.querySelectorAll('[data-vutc-tab]').forEach(function (btn) {
            var isActive = btn.getAttribute('data-vutc-tab') === target;
            btn.classList.toggle('is-active', isActive);
            btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        section.querySelectorAll('[data-vutc-panel]').forEach(function (panel) {
            var isActive = panel.getAttribute('data-vutc-panel') === target;
            panel.classList.toggle('is-active', isActive);
        });
    }

    function resetAndInitVendensSlider(containerId) {
        var container = document.getElementById(containerId);
        if (!container) return;

        var swiperEl = container.querySelector('.swiper');
        if (swiperEl && swiperEl.swiper) {
            swiperEl.swiper.destroy(true, true);
        }

        if (typeof Swiper !== 'undefined' && swiperEl) {
            new Swiper(swiperEl, {
                slidesPerView: 'auto',
                spaceBetween: 20,
                speed: 600,
                resistanceRatio: 0.85,
                grabCursor: true,
                breakpoints: {
                    0: { spaceBetween: 15 },
                    993: { spaceBetween: 20 }
                }
            });
        }

        if (container.dataset && container.dataset.vpsInit === 'true') {
            delete container.dataset.vpsInit;
        }

        if (typeof window.initVendensSlider === 'function') {
            window.initVendensSlider(containerId);
        }
    }

    function getSkeletonCount(limit) {
        var parsed = Number(limit || 4);
        if (!Number.isFinite(parsed)) parsed = 4;
        return Math.max(2, Math.min(4, parsed));
    }

    function buildSkeletonMarkup(count) {
        var total = getSkeletonCount(count);
        var html = '';

        for (var i = 0; i < total; i += 1) {
            html += '<div class="swiper-slide vps-slide vutc-slide vutc-skeleton-slide" aria-hidden="true">' +
                '<div class="vutc-skeleton-card">' +
                '<div class="vutc-skeleton-media vutc-shimmer"></div>' +
                '<div class="vutc-skeleton-body">' +
                '<div class="vutc-skeleton-line vutc-shimmer"></div>' +
                '<div class="vutc-skeleton-line vutc-skeleton-line--short vutc-shimmer"></div>' +
                '<div class="vutc-skeleton-line vutc-skeleton-line--price vutc-shimmer"></div>' +
                '</div>' +
                '</div>' +
                '</div>';
        }

        return html;
    }

    function setTrackLoading(track, isLoading, count) {
        if (!track) return;

        if (isLoading) {
            track.setAttribute('data-vutc-loading', 'true');
            track.setAttribute('aria-busy', 'true');
            track.innerHTML = buildSkeletonMarkup(count);
            return;
        }

        track.removeAttribute('data-vutc-loading');
        track.removeAttribute('aria-busy');
    }

    function fetchProductJSONByHandle(handle) {
        var key = normalizeHandle(handle);
        if (!key) return Promise.resolve(null);

        if (productJsonCache.has(key)) {
            return Promise.resolve(productJsonCache.get(key));
        }

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var endpoint = root + 'products/' + encodeURIComponent(key) + '.js';

        return fetch(endpoint, { credentials: 'same-origin' })
            .then(function (res) {
                if (!res.ok) throw new Error('product_json_failed_' + res.status);
                return res.json();
            })
            .then(function (data) {
                productJsonCache.set(key, data || null);
                return data || null;
            })
            .catch(function () {
                productJsonCache.set(key, null);
                return null;
            });
    }

    function getSlideFromTemplate(template) {
        if (!template || !template.content) return null;

        var wrapper = document.createElement('div');
        wrapper.appendChild(template.content.cloneNode(true));

        return wrapper.querySelector('.vps-slide.vutc-slide');
    }

    function upsertTemplateInStore(store, handle, template) {
        if (!store || !handle || !template || !template.content) return;

        var existing = store.querySelector('template[data-vutc-template-handle="' + handle + '"]');
        if (existing) {
            existing.remove();
        }

        var clone = document.createElement('template');
        clone.setAttribute('data-vutc-template-handle', handle);
        clone.content.appendChild(template.content.cloneNode(true));
        store.appendChild(clone);
    }

    function fetchRecentTemplateFromSection(handle, config) {
        var key = normalizeHandle(handle);
        if (!key || !config.sectionId) return Promise.resolve(null);

        if (remoteTemplateCache.has(key)) {
            return Promise.resolve(remoteTemplateCache.get(key));
        }

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        return fetchProductJSONByHandle(key)
            .then(function (productData) {
                if (!productData || !productData.handle) return null;

                var resolvedHandle = normalizeHandle(productData.handle);
                if (!resolvedHandle) return null;

                var endpoint = root + 'products/' + encodeURIComponent(resolvedHandle) + '?section_id=' + encodeURIComponent(config.sectionId);

                return fetch(endpoint, { credentials: 'same-origin' })
                    .then(function (res) {
                        if (!res.ok) throw new Error('recent_section_failed_' + res.status);
                        return res.text();
                    })
                    .then(function (html) {
                        var parser = new DOMParser();
                        var doc = parser.parseFromString(html || '', 'text/html');

                        var selector = '.vutc-template-store template[data-vutc-template-handle="' + resolvedHandle + '"]';
                        var incomingTemplate = doc.querySelector(selector) || doc.querySelector('template[data-vutc-template-handle="' + resolvedHandle + '"]');
                        if (!incomingTemplate || !incomingTemplate.content) return null;

                        var tpl = document.createElement('template');
                        tpl.setAttribute('data-vutc-template-handle', resolvedHandle);
                        tpl.content.appendChild(incomingTemplate.content.cloneNode(true));
                        remoteTemplateCache.set(key, tpl);
                        return tpl;
                    })
                    .catch(function () {
                        remoteTemplateCache.set(key, null);
                        return null;
                    });
            })
            .then(function (template) {
                if (!template) {
                    remoteTemplateCache.set(key, null);
                    return null;
                }

                return template;
            });
    }

    function renderRecentFromTemplates(section, config) {
        var track = section.querySelector('.js-vutc-recent-track');
        var store = section.querySelector('.vutc-template-store');
        if (!track || !store) return Promise.resolve();

        var currentHandle = getCurrentProductHandle(section);
        var limit = Math.max(4, Math.min(20, Number(config.recentlyViewedLimit || 8)));

        var handles = readRecentHandles(config.recentlyViewedStorageKey)
            .filter(function (h) {
                return h && h !== currentHandle;
            })
            .slice(0, limit);

        var fallbackHTML = track.innerHTML;
        setTrackLoading(track, true, limit);

        return Promise.all(handles.map(function (handle) {
            var existingTemplate = store.querySelector('template[data-vutc-template-handle="' + handle + '"]');
            if (existingTemplate && existingTemplate.content) {
                return Promise.resolve({ handle: handle, template: existingTemplate });
            }

            return fetchRecentTemplateFromSection(handle, config).then(function (fetchedTemplate) {
                if (fetchedTemplate && fetchedTemplate.content) {
                    upsertTemplateInStore(store, handle, fetchedTemplate);
                    return { handle: handle, template: fetchedTemplate };
                }

                return { handle: handle, template: null };
            });
        }))
            .then(function (results) {
                var slides = [];

                results.forEach(function (item) {
                    if (!item || !item.template) return;
                    var slide = getSlideFromTemplate(item.template);
                    if (slide) slides.push(slide);
                });

                if (!slides.length) {
                    var emptyText = track.getAttribute('data-empty-text') || 'Henüz incelediğiniz ürün bulunmuyor.';
                    track.innerHTML = '<div class="swiper-slide vps-slide vutc-slide"><div class="v-card vutc-placeholder">' + escapeHtml(emptyText) + '</div></div>';
                    return;
                }

                track.innerHTML = '';
                slides.forEach(function (slide) {
                    track.appendChild(slide);
                });
            })
            .catch(function () {
                track.innerHTML = fallbackHTML;
            })
            .then(function () {
                setTrackLoading(track, false, limit);
            });
    }

    function fetchRelatedTrackFromRecommendations(section, config) {
        var productId = getCurrentProductId(section);
        var recommendationsUrl = config.recommendationsUrl || (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'recommendations/products' : '');

        if (!productId || !recommendationsUrl || !config.sectionId) {
            return Promise.resolve(null);
        }

        var params = new URLSearchParams();
        params.set('section_id', config.sectionId);
        params.set('product_id', String(productId));
        params.set('limit', String(Math.max(4, Math.min(20, Number(config.relatedLimit || 8)))));
        params.set('intent', 'related');

        var endpoint = recommendationsUrl + '?' + params.toString();

        return fetch(endpoint, { credentials: 'same-origin' })
            .then(function (res) {
                if (!res.ok) throw new Error('recommendations_section_failed_' + res.status);
                return res.text();
            })
            .then(function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html || '', 'text/html');

                var scopedSelector = '.vutc-section[data-section-id="' + config.sectionId + '"] .js-vutc-related-track';
                var incomingTrack = doc.querySelector(scopedSelector) || doc.querySelector('.js-vutc-related-track');
                if (!incomingTrack) return null;

                var hasRealCards = !!incomingTrack.querySelector('.v-card:not(.vutc-placeholder)');
                return {
                    innerHTML: incomingTrack.innerHTML,
                    hasRealCards: hasRealCards
                };
            })
            .catch(function () {
                return null;
            });
    }

    function hydrateRelatedTab(section, config) {
        var track = section.querySelector('.js-vutc-related-track');
        if (!track) return Promise.resolve();

        var fallbackHTML = track.innerHTML;
        setTrackLoading(track, true, config.relatedLimit);

        return fetchRelatedTrackFromRecommendations(section, config)
            .then(function (payload) {
                if (payload && payload.hasRealCards && payload.innerHTML) {
                    track.innerHTML = payload.innerHTML;
                } else {
                    track.innerHTML = fallbackHTML;
                }
            })
            .catch(function () {
                track.innerHTML = fallbackHTML;
            })
            .then(function () {
                setTrackLoading(track, false, config.relatedLimit);
                resetAndInitVendensSlider('vutc-related-' + config.sectionId);
            });
    }

    function bindTabMenu(section, config) {
        var loaded = {
            related: false,
            recent: false
        };

        function loadTab(key) {
            if (key === 'recent') {
                renderRecentFromTemplates(section, config).then(function () {
                    resetAndInitVendensSlider('vutc-recent-' + config.sectionId);
                    loaded.recent = true;
                });
                return;
            }

            if (loaded.related) {
                resetAndInitVendensSlider('vutc-related-' + config.sectionId);
                return;
            }

            hydrateRelatedTab(section, config).then(function () {
                loaded.related = true;
            });
        }

        var initialTab = config.activeTab === 'recent' ? 'recent' : 'related';
        setActiveTab(section, initialTab);
        loadTab(initialTab);

        section.querySelectorAll('[data-vutc-tab]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var target = btn.getAttribute('data-vutc-tab') || 'related';
                setActiveTab(section, target);
                loadTab(target);
            });
        });
    }

    function initSection(section) {
        if (!section || section.dataset.vutcInit === 'true') return;
        section.dataset.vutcInit = 'true';

        var config = getConfig(section);
        updateCurrentProductInStorage(section, config);
        bindTabMenu(section, config);
    }

    function initAll(root) {
        var scope = root || document;
        scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
    }

    document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
    });

    document.addEventListener('shopify:section:load', function (evt) {
        initAll(evt.target || document);
    });
})();
